import ReportDataCollected from './ReportDataCollected';
export default ReportDataCollected;